import CardContentWrapper from './cardContentWrapper.js';
export default CardContentWrapper;
